import { MultiSelectOptionSet } from "../CustomSelect/CustomSelectUtil";

export function isLocationSetSelected(
  locationSet: MultiSelectOptionSet[]
) {
  return locationSet.filter((item) => item.isSelected).length > 0;
}
